export default "__VITE_ASSET__78884d12__"